import { useRef } from "react";
import Banner from "../components/landing/Banner";
import Contact from "../components/landing/Contact";
import FeatCustomer from "../components/landing/FeatCustomer";
import Features from "../components/landing/Features";
import HowDoesWork from "../components/landing/HowDoesWork";
import Pricing from "../components/landing/Pricing";
import Testimonials from "../components/landing/Testimonials";

const LandingXero = () => {
    const sectionRef = useRef(null);

    const scrollToSection = () => {
        sectionRef.current.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <>
            <Banner type="xero" scrollToSection={scrollToSection} />
            <Features />
            <HowDoesWork />
            <Pricing type="xero" scrollToSection={scrollToSection} />
            <FeatCustomer />
            <Testimonials />
            <Contact sectionRef={sectionRef} />
        </>
    );
};

export default LandingXero;
